<template>
  <div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :class="isUrl('home') ? 'text-white' : 'text-blue-300 hover:text-white'" :href="route('dashboard.show')">
        <icon name="dashboard" class="w-4 h-4 mr-2 fill-current"/>
        <div>Dashboard</div>
      </inertia-link>
    </div>
  </div>
</template>

<script>
  import Icon from '@/Shared/Icon';

  export default {
    components: {
      Icon,
    }
  }
</script>
